// extracted by mini-css-extract-plugin
export default {"TabContentHeader":"TabContentHeader_TabContentHeader__YG964","title":"TabContentHeader_title__rLfkS","description":"TabContentHeader_description__g60uu"};